export default "__VITE_ASSET__c46b4d38__"